import { AnswerForType } from "@tellescope/types-models";

/** Shapes a stored answer value into the form `@tellescope/validation`'s validators expect. */
export const getValueForValidation = <T extends keyof AnswerForType>(type: T, value: AnswerForType[T]) => {
  switch (type) {
    case "signature": {
      const typedValue = value as AnswerForType["signature"];
      return {
        type: "signature",
        fullName: typedValue?.fullName ?? "",
        signed: !!typedValue?.signed,
      };
    }
    case "date": {
      const typedValue = value as AnswerForType["date"];
      return typedValue?.toISOString() ?? "";
    }
    default:
      return value;
  }
};
